var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBagNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 5.00005H15C15 2.5 12.7614 0 10 0C7.23856 0 5 2.5 5 5.00005H1C0.45 5.00005 0 5.45005 0 6.00005C0 6.09005 0.00999996 6.18005 0.04 6.27005L2.58 15.54C2.81 16.38 3.58 17 4.5 17H15.5C16.42 17 17.19 16.38 17.43 15.54L19.97 6.27005L20 6.00005C20 5.45005 19.55 5.00005 19 5.00005ZM7 5.00005H13C13 3.34318 11.6569 2 10 2C8.34313 2 6.99997 3.34318 7 5.00005ZM4.51 15.01L15.5 15L17.7 7.00005H2.31L4.51 15.01Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagNew);
export default __webpack_public_path__ + "static/media/BagNew.dff9de03616ababba764c77a9edd9a0e.svg";
export { ForwardRef as ReactComponent };